<template>
  <div style="text-align: center; margin-top: 10px" class="pagination-wrap">
    <zm-pagination
      @current-change="onPageChanged"
      @size-change="onPageSizeChanged"
      :current-page.sync="pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="count"
    >
    </zm-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['total'],
  watch: {
    total: function (newValue) {
      this.count = newValue
    }
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      count: 0
    }
  },
  methods: {
    onPageChanged(pageNo) {
      this.pageNo = pageNo
      this.$emit('page-changed', this.pageNo)
    },
    onPageSizeChanged(pageSize) {
      this.pageSize = pageSize
      this.$emit('size-changed', this.pageSize)
    },
    setCount(value) {
      this.count = value
    }
  }
}
</script>

<style scoped></style>
